import service from './config.api';

export const CONFIGURATIONS_ENDPOINT =
  'configurations/admin/application-configurations';
export const CONFIGURATION_ENDPOINT = uniqueName =>
  `${CONFIGURATIONS_ENDPOINT}/${uniqueName}`;

// endpoints
service.getConfiguration = async uniqueName => {
  const response = await service.get(CONFIGURATION_ENDPOINT(uniqueName));
  return response.data;
};

service.getConfigurations = async params => {
  const response = await service.get(CONFIGURATIONS_ENDPOINT, {
    params: params,
  });
  return response.data;
};

service.createConfiguration = async configuration => {
  const response = await service.post(CONFIGURATIONS_ENDPOINT, configuration);
  return response.data;
};

service.updateConfiguration = async (uniqueName, configuration) => {
  const response = await service.patch(
    CONFIGURATION_ENDPOINT(uniqueName),
    configuration
  );

  return response.data;
};

service.deleteConfiguration = async uniqueName => {
  const response = await service.delete(CONFIGURATION_ENDPOINT(uniqueName));
  return response.data;
};

export default service;
